import { FC } from 'react'

import { PageContent } from 'components/common/Page/PageContent'
import { PlanContentModule } from 'components/pages/Workspace/PlanContent'

export const WorkspacePlanContent: FC = () => {
  return (
    <PageContent>
      <PlanContentModule />
    </PageContent>
  )
}
